<script>
  import Layout from '@layouts/main.vue'

  export default {
    page: {
      title: 'Page timeout',
      meta: [
        { name: 'description', content: 'The page timed out while loading.' },
      ],
    },
    components: { Layout },
  }
</script>

<template>
  <Layout>
    <el-row :class="$style.timeoutView" type="flex" justify="end" align="middle">
      <el-col :span="24" :md="{ span: 22, offset: 1 }" :class="$style.detailsContainer">
        <h4>The page timed out while loading. <br> Are you sure you're still connected to
          the Internet?</h4>
      </el-col>
    </el-row>
  </Layout>
</template>

<style lang="scss" module>
  @import '@design';

  .timeoutView {
    height: 75vh;
    text-align: center;
  }

  .detailsContainer {
    h4 {
      color: $color-text-tetriary;
    }
  }
</style>
